module.exports = __webpack_public_path__ + "img/financelogo.6a7d457d.png";